import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Field, Formik } from "formik";
import {
  Center,
  FlexContainer,
} from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/content/new";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import { hideModal } from "../../../../../../store/actions/modal";
import { AcademyDto } from "../../../../../../types/academy.dto";
import { CurrentDto } from "../../../../../../types/current.dto";
import DinamicField from "../../../../../../components/Form/DinamicField";
import { LetterModal } from "./style";
import { CohortDto } from "../../../../../../types/cohort.dto";
import { UnitDto } from "../../../../../../types/unit.dto";
import { StateDto } from "../../../../../../types/states.dto";
import { UserDto } from "../../../../../../types/user.dto";
import { setFormData } from "../../../../../../helpers/formData";
import contentActions from "../../../../../../store/actions/content";
import DinamicLinked from "../../../../../../components/Form/DinamicLinked";
import Loader from "../../../../../../components/Loader";

const Component = ({
  academies,
  cohorts,
  current,
  units,
  updateStates,
  user,
  contentDataChanged,
  imageApi,
  currentImage,
  content,
  createStates,
}: {
  academies: AcademyDto[];
  cohorts: CohortDto[];
  current: CurrentDto;
  units: UnitDto[];
  updateStates: StateDto;
  user: UserDto;
  contentDataChanged;
  imageApi;
  currentImage;
  content;
  createStates;
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const [activeAcademy, setActiveAcademy] = useState<any>();
  const dispatch = useDispatch();
  const onSubmit = ({ values, actions }) => {
    if (!content) {
      dispatch(
        contentActions.create(
          setFormData(
            {
              name: values.name,
              cohorts: values.cohorts.map((cohort) =>
                !!cohort.value ? cohort.value : cohort
              ),
              description: values.description,

              units: values.units.map((unit) =>
                !!unit.value ? unit.value : unit
              ),
              link: values.link,
              ...(!!currentImage && { picture: currentImage.file }),
              type: "MISC",

              academy: current.id,
              published: true,
              allCohorts: values.allCohorts,
              available: values.available,
            },
            ["picture"]
          )
        )
      );
    } else {
      dispatch(
        contentActions.update({
          _id: content._id,
          body: setFormData(
            {
              name: values.name,
              cohorts: values.cohorts.map((cohort) =>
                !!cohort.value ? cohort.value : cohort
              ),
              description: values.description,

              units: values.units.map((unit) =>
                !!unit.value ? unit.value : unit
              ),
              ...(!!currentImage && { picture: currentImage.file }),
              link: values.link,
              published: true,
              allCohorts: values.allCohorts,
              available: values.available,
              __v: content.__v,
            },
            ["picture"]
          ),
        })
      );
    }

    setFormActions(actions);
  };
  useEffect(() => {
    if (updateStates.success) {
      setTimeout(() => {
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }
  }, [updateStates]);

  useEffect(() => {
    if (createStates.success) {
      setTimeout(() => {
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }
  }, [createStates]);
  return (
    <Modal name="publish-content-modal" title={`Publicar Contenido`}>
      {!units ? (
        <Loader color="Primary"></Loader>
      ) : (
        <Formik
          initialValues={{
            ...initialValues({
              name: contentDataChanged.name,
              description: contentDataChanged.description,
              link: contentDataChanged.link,
              ...(!!content && {
                available: content.available,
                cohorts: content.cohorts,
                units: content.units.map((unit) => {
                  const unitFounded = units.find(
                    (unitFounded) => unitFounded._id === unit
                  );
                  return {
                    label: unitFounded?.name,
                    value: unitFounded?._id,
                  };
                }),
                allCohorts: content.allCohorts,
              }),
            }),
          }}
          onSubmit={(values, actions) => {
            if (onSubmit) onSubmit({ values, actions });
          }}
          validateOnChange={formSubmmited}
          validateOnMount={true}
          validateOnBlur={false}
          validationSchema={schema}
          enableReinitialize
        >
          {({
            touched,
            errors,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            setFieldValue,
            isSubmitting,
          }) => {
            return (
              <form
                className="theme-form"
                onSubmit={(event) => {
                  Object.entries(errors).forEach((item) => {
                    toast.error(item[1] as string);
                  });
                  setFormSubmmited(true);
                  handleSubmit(event);
                }}
                id="publish-form-content"
              >
                <Grid.Row style={{ marginBottom: "20px" }}>
                  <Grid.Col>
                    <FlexContainer
                      justify="space-between"
                      style={{ padding: "0px 0px 0px 20px" }}
                    >
                      <FlexContainer
                        direction="column"
                        gap="2px"
                        style={{ maxWidth: "300px" }}
                      >
                        <FlexContainer align="center" gap="1px">
                          <LetterModal lg>Publicación General</LetterModal>
                          <LetterModal lg gray>
                            (Recomendado):
                          </LetterModal>
                        </FlexContainer>
                        <LetterModal gray>
                          El contenido se publicara para todo el publico de
                          Constana Campus, dándole visibilidad a tu Academia y
                          contenidos a nuevos usuarios.
                        </LetterModal>
                      </FlexContainer>
                      <Field
                        style={{
                          width: "20px",
                          height: "20px",
                          boxShadow: "0 0 4px 0 rgba(21, 115, 229, 0.16)",
                        }}
                        type="checkbox"
                        name="available"
                      />
                    </FlexContainer>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row style={{ marginBottom: "20px" }}>
                  <Grid.Col>
                    <FlexContainer
                      justify="space-between"
                      style={{ padding: "0px 0px 0px 20px" }}
                    >
                      <FlexContainer
                        direction="column"
                        gap="2px"
                        style={{ maxWidth: "300px" }}
                      >
                        <FlexContainer align="center" gap="1px">
                          <LetterModal lg>Compartir entre Cohorts</LetterModal>
                        </FlexContainer>
                        <LetterModal gray>
                          Mostrar a todos los cohorts de la academia
                        </LetterModal>
                      </FlexContainer>
                      <Field
                        style={{
                          width: "20px",
                          height: "20px",
                          boxShadow: "0 0 4px 0 rgba(21, 115, 229, 0.16)",
                        }}
                        type="checkbox"
                        name="allCohorts"
                      />
                    </FlexContainer>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <DinamicField
                      name="cohorts"
                      error={errors["cohorts"]}
                      touched={touched["cohorts"]}
                      value={values["cohorts"]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={{
                        itemOnClick: {
                          functionItem: (value) =>
                            setActiveAcademy((state) =>
                              state === value ? undefined : value
                            ),
                          value: activeAcademy,
                        },
                        onDelete: (item, index) => {
                          setFieldValue(
                            "units",
                            values["units"].filter((val) => val.linked !== item)
                          );
                        },
                        skin: "gray",
                        type: "select",
                        height: "95px",
                        ...(!!cohorts && {
                          data: cohorts
                            .filter(
                              (cohort) =>
                                cohort.active &&
                                cohort.academy._id === current.id
                            )
                            .map((cohort) => {
                              return { value: cohort._id, label: cohort.name };
                            }),
                        }),
                        loading: !cohorts,
                        inputLabel: "Seleccionar Cohorts (Opcional)",
                        inputPlaceholder: "Selecciona un Cohort",
                      }}
                    />
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <DinamicLinked
                      name="units"
                      error={errors["units"]}
                      touched={touched["units"]}
                      value={values["units"]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={{
                        notLoading: true,
                        skin: "gray",
                        type: "select",
                        height: "95px",
                        ...(!!units &&
                          !!activeAcademy && {
                            data: units
                              .filter(
                                (unit) =>
                                  unit.active &&
                                  unit.cohort.includes(activeAcademy)
                              )
                              .map((cohort) => {
                                return {
                                  linked: activeAcademy,
                                  value: cohort._id,
                                  label: cohort.name,
                                };
                              }),
                          }),
                        externalData: true,
                        loading: !units,
                        inputLabel:
                          "Seleccionar Módulos del Cohort Seleccionado",
                        inputPlaceholder: "Selecciona un Modulo",
                      }}
                    ></DinamicLinked>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col>
                    <Center gap={"10px"}>
                      <Submit
                        isSubmmiting={
                          !!content
                            ? updateStates.loading
                            : createStates.loading
                        }
                        form="publish-form-content"
                        color="Primary"
                        style={{ width: "170px" }}
                        options={{
                          type: "filled",
                          skin: "primary",
                          size: "lg",
                          marginBottom: "0px",
                        }}
                      >
                        Confirmar
                      </Submit>
                      <Button
                        onClick={resetForm}
                        type="button"
                        options={{
                          type: "outline",
                          skin: "danger",
                          size: "lg",
                          marginBottom: "0px",
                        }}
                        style={{ marginLeft: "10px", width: "170px" }}
                      >
                        Cancelar
                      </Button>
                    </Center>
                  </Grid.Col>
                </Grid.Row>
              </form>
            );
          }}
        </Formik>
      )}
    </Modal>
  );
};

const states = ({
  academyStore,
  cohortStore,
  currentStore,
  unitStore,
  userStore,
  contentStore,
}) => {
  const { data: academies } = academyStore.all;
  const { data: cohorts } = cohortStore.allCohorts;
  const { data: current } = currentStore;
  const { data: units } = unitStore.allUnits;
  const { states: updateStates } = contentStore.update;
  const { states: createStates } = contentStore.create;
  const { data: user } = userStore;
  return {
    academies,
    cohorts,
    current,
    units,
    updateStates,
    user,
    createStates,
  };
};

export default connect(states)(Component);
